import { useMemo } from 'react';
import { useWorkflowForm } from '../CampaignWorkflowFormContext';

export const useValidationResults = () => {
  const { state } = useWorkflowForm();

  return useMemo(() => state.validationResults, [state.validationResults]);
};
